import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { Cartola, cartolaType } from "../../types/slices/cartolaType"
import { RootState } from "../store"

const initialState: cartolaType = {
    status: ApiStatus.FETCHED,
    cartolas: [],
    totalRows: 0,
    cartolaSelected: {} as Cartola,
    errorMessage: undefined
}

const cartolaSlice = createSlice({
    name: 'cartolaSlice',
    initialState,
    reducers: {
        onFetchCartolas(state, { payload }: { payload: Cartola[] }) {
            state.status = ApiStatus.FETCHED
            state.cartolas = payload
            state.errorMessage = undefined
        },
        onSetSelectedCartola(state, { payload }: { payload: Cartola }) {
            state.cartolaSelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
        onFetchTotalRows(state, { payload }: { payload: number }) {
            state.totalRows = payload
        }
    }
})

export const selectCartolaState = (state: RootState) => state.cartolaSlice
export default cartolaSlice.reducer
export const {
    onFetchCartolas,
    onSetSelectedCartola,
    changeStatus,
    onFetchTotalRows
} = cartolaSlice.actions